import { InjectionKey } from 'vue';
import { Language } from '@/common/domain/Language';

export const fanLanguageRepositoryKey: InjectionKey<FanLanguageRepository> = Symbol();

export interface FanLanguageRepository {
  getCurrentLanguage(): Language;
  storeLanguage(locale: Language): void;
}
